export default () => {

  $('.main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    fade: true,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          dots: false
        }
      }
    ]
  });

  $('.awards__slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerMode: true,
          centerPadding: '60px',
        }
      }
    ]
  });

  $('.contacts__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  const productsSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 767,
        settings: "unslick"
      }
    ]
  };

  const sl = $('.products-slider').slick(productsSettings);

  $(window).on('resize', function () {
    if ($(window).width() > 767 && !sl.hasClass('slick-initialized')) {
      $('.products-slider').slick(productsSettings);
    }
  });

  $('.product-card__for-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-card__nav-slider'
  });
  $('.product-card__nav-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    asNavFor: '.product-card__for-slider',
    vertical: true,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          vertical: false,
          verticalSwiping: false
         }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          arrows: false,
          vertical: false,
          verticalSwiping: false
        }
      }
    ]
  });

  $('.info-page__slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.info-page__slider-nav'
  });
  $('.info-page__slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    asNavFor: '.info-page__slider-for',
    vertical: true,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          vertical: false,
          verticalSwiping: false
        }
      },
    ]
  });

  $('.installment-plan__slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.about__slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow: '<span class="slick-prev"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.0955 11.9822L6.68994 10.5179L3.07565 6.00004L6.68994 1.48218L5.0955 0.0178985L0.30979 6.00004L5.0955 11.9822Z"/></svg></span>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        }
      }
    ]
  });

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js